var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredByCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1106 9.84334H27.6228L26.48 0H30.2534L29.1106 9.84334Z",
    fill: "url(#paint0_linear_3220_17106)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1887 10.9261L20.8302 11.4886L16.0434 2.81344L19.5149 1.36398L22.1887 10.9261Z",
    fill: "url(#paint1_linear_3220_17106)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6376 10.0396L24.1714 10.3209L21.1742 0.866937L24.8829 0.153025L25.6376 10.0396Z",
    fill: "url(#paint2_linear_3220_17106)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0737 40.2387L16.1302 41.2771L9.98493 49.0652L7.31119 46.3826L15.0737 40.2387Z",
    fill: "url(#paint3_linear_3220_17106)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7198 44.3702L22.0783 44.9543L19.3398 54.4731L15.8683 53.0237L20.7198 44.3702Z",
    fill: "url(#paint4_linear_3220_17106)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6609 42.5548L18.8899 43.3985L14.3618 52.2034L11.2353 50.0833L17.6609 42.5548Z",
    fill: "url(#paint5_linear_3220_17106)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1274 14.6267L15.0708 15.6868L7.30833 9.52115L9.98207 6.83857L16.1274 14.6267Z",
    fill: "url(#paint6_linear_3220_17106)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.796 17.2225L12.9766 18.4556L4.1791 13.9125L6.29222 10.7756L13.796 17.2225Z",
    fill: "url(#paint7_linear_3220_17106)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0575 12.4207L17.8069 13.2427L11.4675 5.62768L14.6157 3.55084L19.0575 12.4207Z",
    fill: "url(#paint8_linear_3220_17106)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5724 40.3714L40.5158 41.4315L46.7043 49.2845L49.3996 46.5803L41.5724 40.3714Z",
    fill: "url(#paint9_linear_3220_17106)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.771 44.6118L34.3694 45.1742L37.0647 54.8229L40.601 53.3734L35.771 44.6118Z",
    fill: "url(#paint10_linear_3220_17106)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7898 42.8388L37.5392 43.6609L42.0242 52.6172L45.2154 50.5187L38.7898 42.8388Z",
    fill: "url(#paint11_linear_3220_17106)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8919 46.2537H27.4041L26.2397 56.2052H30.0563L28.8919 46.2537Z",
    fill: "url(#paint12_linear_3220_17106)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3624 45.7767L30.8962 46.058L31.6724 56.0528L35.4027 55.3172L32.3624 45.7767Z",
    fill: "url(#paint13_linear_3220_17106)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7387 45.7346L25.2049 46.0375L24.3208 56.0106L20.5905 55.2534L23.7387 45.7346Z",
    fill: "url(#paint14_linear_3220_17106)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9952 34.2053L11.5558 35.6115L2.82302 40.4574L1.37834 36.9311L10.9952 34.2053Z",
    fill: "url(#paint15_linear_3220_17106)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1112 30.723L10.3915 32.2157L0.882476 35.2445L0.149352 31.5018L10.1112 30.723Z",
    fill: "url(#paint16_linear_3220_17106)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5042 37.3864L13.3235 38.6411L5.66887 45.088L3.57731 41.9078L12.5042 37.3864Z",
    fill: "url(#paint17_linear_3220_17106)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91873 27.2188V28.7115L0 29.8797V26.0505L9.91873 27.2188Z",
    fill: "url(#paint18_linear_3220_17106)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6211 20.2112L11.0389 21.5957L1.44359 18.8266L2.90983 15.3003L11.6211 20.2112Z",
    fill: "url(#paint19_linear_3220_17106)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.436 23.5412L10.1342 25.0123L0.193872 24.1253L0.948558 20.3827L10.436 23.5412Z",
    fill: "url(#paint20_linear_3220_17106)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6256 10.9685L36.0056 11.5309L40.8572 2.87746L37.3641 1.428L34.6256 10.9685Z",
    fill: "url(#paint21_linear_3220_17106)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8184 12.5246L39.0475 13.3466L45.4947 5.8181L42.3681 3.698L37.8184 12.5246Z",
    fill: "url(#paint22_linear_3220_17106)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2851 10.0581L32.7298 10.361L35.8348 0.95035L32.1476 0.19317L31.2851 10.0581Z",
    fill: "url(#paint23_linear_3220_17106)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5991 14.6247L41.6341 15.6847L49.3966 9.51911L46.7228 6.83653L40.5991 14.6247Z",
    fill: "url(#paint24_linear_3220_17106)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3816 27.2158V28.7085L56.3003 29.8767V26.0475L46.3816 27.2158Z",
    fill: "url(#paint25_linear_3220_17106)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7219 20.3145L45.3041 21.7207L54.921 19.0165L53.4763 15.4685L44.7219 20.3145Z",
    fill: "url(#paint26_linear_3220_17106)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2604 34.3328L44.6782 35.7173L53.3895 40.6282L54.8557 37.1019L45.2604 34.3328Z",
    fill: "url(#paint27_linear_3220_17106)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9079 23.7317L46.1882 25.2028L56.15 24.424L55.4169 20.6813L45.9079 23.7317Z",
    fill: "url(#paint28_linear_3220_17106)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6865 37.5569L42.8456 38.8116L50.4356 45.3234L52.5702 42.1648L43.6865 37.5569Z",
    fill: "url(#paint29_linear_3220_17106)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9749 17.2857L43.7943 18.5404L52.7211 14.0406L50.6296 10.8388L42.9749 17.2857Z",
    fill: "url(#paint30_linear_3220_17106)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1442 30.9148L45.8424 32.3859L55.3298 35.5445L56.1061 31.8018L46.1442 30.9148Z",
    fill: "url(#paint31_linear_3220_17106)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6792 16.0527L21.9492 29.8334H29.453L33.6792 16.0527Z",
    fill: "url(#paint32_linear_3220_17106)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6094 40.4779L35.3178 26.6973H27.8141L23.6094 40.4779Z",
    fill: "url(#paint33_linear_3220_17106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3220_17106",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3220_17106",
    x1: 31.9645,
    y1: 18.0715,
    x2: 22.3424,
    y2: 26.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3220_17106",
    x1: 33.6062,
    y1: 28.716,
    x2: 23.987,
    y2: 36.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByCircle);
export default __webpack_public_path__ + "static/media/PoweredByCircle.a16c0bc31c49744beb4fe987e2e5cf3c.svg";
export { ForwardRef as ReactComponent };